/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetETFDetailsRequest} from '@cash-web/protos/squareup/cash/marketdata/server/investment_metrics_service.pb'
import {GetETFDetailsResponse} from '@cash-web/protos/squareup/cash/marketdata/server/investment_metrics_service.pb'


export const getETFDetails = (request:GetETFDetailsRequest, options?: CashRequestOptions) => post<GetETFDetailsRequest, GetETFDetailsResponse>("/2.0/cash/get-e-t-f-details", request, {...options, rejectOnError: true })